import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import DeleteAccount from "../Page/DeleteAccount/DeleteAccount";

export default function Router() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DeleteAccount />} />
          <Route path="/delete_account" element={<DeleteAccount />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
